import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_traveller_information_validation_highlight",
  stages: {
    had_any_validation_error: 1,
    had_email_error: 2,
    desktop: 3,
    mdot: 4,
    solo_traveler: 5,
    couple: 6,
    group: 7
  },
  defaultStage: 1,
  goals: {
    any_error_and_clicked_pay: 1,
    email_error_reached_checkout: 2,
    phone_error_reached_checkout: 3
  }
});

const { stages, goals } = utils;

export const useTrackPaxValidationStages = () => {
  const { isDesktop, isMobile, isSolo, isCouple, isGroup } = useProfiler();

  const trackValidationStages = useCallback(() => {
    isDesktop() && stages.desktop();
    isMobile() && stages.mdot();

    if (isSolo()) {
      stages.solo_traveler();
    } else if (isCouple()) {
      stages.couple();
    } else if (isGroup()) {
      stages.group();
    }
  }, [isDesktop, isMobile, isSolo, isCouple, isGroup]);

  const trackHadAnyValidationErrorStage = useCallback(() => {
    stages.had_any_validation_error();
  }, []);

  const trackHadEmailValidationErrorStage = useCallback(() => {
    stages.had_email_error();
  }, []);

  return { trackValidationStages, trackHadAnyValidationErrorStage, trackHadEmailValidationErrorStage };
};

export const useTrackPaxValidationGoals = () => {
  const trackAnyValidationErrorAndClickPay = useCallback(() => {
    goals.any_error_and_clicked_pay();
  }, []);

  const trackEmailValidationErrorReachedCheckout = useCallback(() => {
    goals.email_error_reached_checkout();
  }, []);

  const trackPhoneValidationErrorReachedCheckout = useCallback(() => {
    goals.phone_error_reached_checkout();
  }, []);

  return {
    trackAnyValidationErrorAndClickPay,
    trackEmailValidationErrorReachedCheckout,
    trackPhoneValidationErrorReachedCheckout
  };
};

export default utils;
